import { usePermission } from "../hooks/usePermission";

export function canViewNotifications() {
  return usePermission("USOrderDetailsNotifications:view");
}
